// src/auth/msalConfig.ts
import { PublicClientApplication, BrowserCacheLocation } from "@azure/msal-browser";

const getRedirectUri = () => {
  if (window.location.hostname === "localhost") {
    // Match Vite dev server port
    return "http://localhost:3000";
  }
  return "https://evals.myenterprise.ai/";
};

const msalConfig = {
  auth: {
    clientId: "9f6ac8e3-7d78-4b63-b7b2-2a2b11cad188", // Replace with your Entra app client ID
    authority: "https://eaidevmyentepriseai.ciamlogin.com/50808ce0-f31b-4fd0-9861-74b83b8c112a", // Replace with your tenant ID or common for multi-tenant apps
    redirectUri: getRedirectUri(), // Dynamically set redirect URI
    postLogoutRedirectUri: getRedirectUri(), // Redirect after logout
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

